import { useAutoDismissToast } from "@/components/manufacturing/useAutoDismissToast";

type Props = {
  message: string | null;
  onDismiss: () => void;
};

/** Sticky success banner after document editor saves. */
export function DocumentEditorSaveFeedback({ message, onDismiss }: Props) {
  useAutoDismissToast(message, onDismiss, 4000);

  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-20 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-800 shadow-sm dark:border-green-800 dark:bg-green-950/50 dark:text-green-200"
    >
      {message}
    </div>
  );
}

export function DocumentEditorSavedLabel({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <span
      role="status"
      aria-live="polite"
      className="text-sm font-medium text-green-700 dark:text-green-300"
    >
      Saved
    </span>
  );
}

const SAVE_FLASH_BUTTON_CLASS =
  "border-green-500 bg-green-50 text-green-800 ring-2 ring-green-400/60 dark:border-green-600 dark:bg-green-950/40 dark:text-green-200 dark:ring-green-500/40";

/** Apply while `active`; pair with a ~1s timeout that clears saveFlash. */
export function saveFlashButtonClass(active: boolean, baseClass: string): string {
  return active ? `${baseClass} ${SAVE_FLASH_BUTTON_CLASS}` : baseClass;
}
